module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter23"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch23"
    }
  }, [_vm._v("Confetti Split Pea and Smoked Sausage Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Split pea soup is one of my family’s favorites. I’m not sure if the thyme or the smoked sausage flavors the thick soup more—either way, it’s nice for lunch or dinner, and leftovers freeze well. I like to use yellow and green split peas as well as red lentils, but it’s also fine to only use green split peas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1½ pounds smoked sausage, cut into")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½-inch rounds")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 medium carrots, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 stalks celery with leaves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1½ cups dried green split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup dried yellow split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 cups chicken or vegetable broth (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cook the sausage in a large skillet over high heat. Render the fat and remove all but 2 tablespoons from the skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the onion, carrots, celery, and thyme and sauté until the vegetables are softened, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the remaining ingredients, except salt and pepper, and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover and cook on high for 4 to 5 or on low for 8 to 10 hours, until the peas have split and the soup is thick. Check the soup several times during cooking to make sure there is enough broth and the soup isn’t sticking to the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" slow-cooker liquid savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As I said in the introduction, all slow cookers are different and their temperatures vary a bit. The cooking time and amount of liquid that evaporates may vary. Just to be on the safe side, check the soup during the day to make sure that it’s not sticking to the pan and that there is enough liquid.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1393f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/029-chapter23.vue
// module id = 141
// module chunks = 0